import set from 'lodash-es/set';
import { IChannelListFilter } from 'pages/Conversations/interfaces/IChannelListFilter';
import { IChannelListFilterSelection } from 'pages/Conversations/interfaces/IChannelListFilterSelection';
import { ChannelListFilterSelectionDraft } from '../types/ChannelListFilterSelectionDraft';

export const convertDraftFilterToPersisted = (
  filterDraft: ChannelListFilterSelectionDraft,
): IChannelListFilterSelection => {
  const persistedFilters = Object.entries(filterDraft.filters).reduce((prev, [key, value]) => {
    if (!Array.isArray(value)) {
      return set(prev, key, value);
    } else {
      return set(
        prev,
        key,
        value.map((v) => v.value),
      );
    }
  }, {} as IChannelListFilter);
  // TODO: Save unread filter state in a future iteration
  persistedFilters.unread = false;
  return {
    ...filterDraft,
    filters: persistedFilters,
  };
};
